import React from 'react';

const CommissionList = ({ commissions }) => {
  return (
    <ul>
      {commissions.map(commission => (
        <li key={commission.id}>
          Venta ID: {commission.saleId} - ${commission.amount} ({commission.status})
        </li>
      ))}
    </ul>
  );
};

export default CommissionList;